export default function AlaramIco({ color }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 3.66536L3.33333 2.33203M14 3.66536L12.6667 2.33203M8 5.66536V8.33203L9.33333 9.66536M13.3333 8.33203C13.3333 11.2776 10.9455 13.6654 8 13.6654C5.05448 13.6654 2.66667 11.2776 2.66667 8.33203C2.66667 5.38651 5.05448 2.9987 8 2.9987C10.9455 2.9987 13.3333 5.38651 13.3333 8.33203Z"
        stroke={color || "#D55F00"}
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
